<template>
  <div v-loading="listContentLoading">
    <el-button
      style="padding: 0; margin: 20px;"
      type="text"
      icon="el-icon-back"
      @click="$router.go(-1)"
    >
      返回
    </el-button>

    <el-input
      class="search-el"
      size="mini"
      v-model="query.search"
      clearable
      placeholder="请输入用户昵称/手机号"
    ></el-input>

<!--    <el-select
      class="search-el"
      size="mini"
      v-model="query.order_source"
      clearable
      placeholder="订单来源"
    >
      <el-option label="全部" value="">全部</el-option>
      <el-option label="灵动生活APP" value="app">灵动生活APP</el-option>
      <el-option label="灵动生活H5" value="h5">灵动生活H5</el-option>
      <el-option label="抖音" value="backend_activity_import_dy"
        >抖音</el-option
      >
      <el-option label="小鹅通" value="xiaoetong">小鹅通</el-option>
      <el-option label="视频号" value="backend_activity_import_wxvideo"
        >视频号</el-option
      >
    </el-select>-->


    <el-button type="primary" size="mini" @click="activityOrderList()"
      >查询</el-button
    >

    <el-row>
      <el-table
        ref="multipleTable"
        v-loading="loading"
        :data="list"
        border
        size="mini"
        :stripe="true"
        style="width: 100%; margin: 20px 0;"
      >
        <el-table-column
            prop="id"
            label="订单ID"
            align="center"
            min-width="8%"
        ></el-table-column>
        <el-table-column
            prop="order_no"
            label="订单号"
            align="center"
            min-width="8%"
        ></el-table-column>
        <el-table-column
            prop="body"
            label="内容"
            align="center"
            min-width="8%"
        ></el-table-column>
        <el-table-column
          prop="nickname"
          label="用户昵称"
          align="center"
          min-width="8%"
        ></el-table-column>
        <el-table-column
          prop="mobile_phone"
          label="手机号"
          align="center"
          min-width="8%"
        ></el-table-column>

        <el-table-column
          prop="created_at"
          label="下单时间"
          align="center"
          min-width="8%"
        ></el-table-column>

        <el-table-column
          prop="source_msg"
          label="订单来源"
          align="center"
          min-width="8%"
        ></el-table-column>

        <el-table-column
          prop="total_amount"
          label="订单金额"
          align="center"
          min-width="8%"
        ></el-table-column>
        <el-table-column
            prop="balance_amount"
            label="余额支付金额"
            align="center"
            min-width="8%"
        ></el-table-column>
      </el-table>
    </el-row>
    <el-row>
      <div class="block">
        <el-pagination
          background
          @current-change="activityOrderList"
          :current-page.sync="query.page"
          :page-size="query.limit"
          layout="total, prev, pager, next, jumper"
          :total="total"
        >
        </el-pagination>
      </div>
    </el-row>
  </div>
</template>

<script>
import { activityOrderList } from "@/api/productActivity";

export default {
  data: function () {
    return {
      dialogVisible: false,
      list: [],
      loading: false,
      total: 0,
      query: {
        page: 1,
        limit: 20,
        activity_id: this.$route.query.activity_id,
        search: "",
        order_source: "",
        cashback_status: "0",
      },

      listContentLoading: false,

      multipleSelection: [],
    };
  },
  created: function () {
    this.activityOrderList();
  },
  methods: {
    activityOrderList() {
      this.loading = true;
      activityOrderList(this.query).then((response) => {
        this.list = response.data.list;
        this.total = response.data.total;
        this.loading = false;
      });
    },


  },
  mounted() {},
};
</script>
